/**
 * Cashier Methods Collection
 */

define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const CashierMethodCollection = require('portlets/cashier/cashier.method.collection');
    const cashierConfig = require('portlets/cashier/cashier.config');
    const configure = require('config');
    const urlUtil = require('util/url.util');
    const dispatcher = require('bundle').dispatcher;
    const historyUtil = require('util/history.util');
    const i18n = require('i18n');

    module.exports = CashierMethodCollection.extend({
        parse: function(response) {
            const config = cashierConfig();
            const hideParentPaymentMethods = this.config.hideParentPaymentMethods;
            let methods = response.methods.data.payments ? response.methods.data.payments.method : [];

            const accounts = response.accounts.data.payments
                ? _.indexBy(response.accounts.data.payments.method, 'code')
                : {};
            const skippedSubMethods = ['DotpayBankTransfer', 'PayPalViaSC'];
            const subMethods = {};
            const getSubMethods = function(method) {
                if (!method.subMethods) {
                    return;
                }

                if (skippedSubMethods.includes(method.code)) {
                    method.subMethods.subMethod = method.subMethods.subMethod.sort(function(a, b) {
                        const aOrder = a.ordering && a.ordering[this.paymentMethodsOrder] || 999;
                        const bOrder = b.ordering && b.ordering[this.paymentMethodsOrder] || 999;

                        return aOrder - bOrder;
                    }.bind(this));

                    return;
                }

                _.each(method.subMethods.subMethod, function(subMethod) {
                    if (!subMethods[method.code]) {
                        subMethods[method.code] = [];
                    }

                    subMethods[method.code].push(
                        _.extend(
                            _.omit(method, 'subMethods'),
                            {
                                code: subMethod.code,
                                methodCode: method.code,
                                name: subMethod.name,
                                ordering: subMethod.ordering,
                                reDirectType: subMethod.reDirectType || method.reDirectType,
                                isSubMethod: true
                            }
                        )
                    );
                });
            }.bind(this);

            const addSubMethods = function(res, method) {
                if (subMethods[method.code]) {
                    _.each(subMethods[method.code], function(subMethod) {
                        res[subMethod.code] = subMethod;
                    });
                }
                res[method.code] = method;
                return res;
            };

            const filterParentMethods = function(method) {
                return !(hideParentPaymentMethods && method.hideParentMethod && subMethods[method.code]);
            };

            methods = _.chain(methods)
                .each(this.addCommonFields.bind(this))
                .each(getSubMethods)
                .reduce(addSubMethods, {})
                .filter(filterParentMethods)
                .each(this.mergeWithAccountFields.bind(this, accounts))
                .each(this.addAccountsToSubMethods.bind(this, accounts))
                .each(this.removeHiddenAccounts)
                .each(this.deleteAccountsWithoutSpecParams)
                .value();

            if (this.isVisaCheckoutEnabled()) {
                this.extractVisaCheckoutCCToNewMethod(methods);
            }

            methods = _.chain(methods).filter(this.removeCreditCardMethodsWithNoAccounts.bind(this, config)).value();

            methods = this.afterParse(methods, config, response);

            return methods;
        },

        afterParse: function(methods, config, initialResponse) { // eslint-disable-line no-unused-vars
            // override

            methods.forEach(function(method) {
                if (method.code === 'VIS' || method.code === 'ECA') {
                    if (method.account) {
                        method.account.forEach(function(creditCard, i) {
                            var expMonth = creditCard.specificParams.field4;
                            var dateNow = new Date(Date.now());
                            // get first two digits of year
                            var yearCentury = Number(dateNow.getFullYear().toString().substr(0, 2));
                            var expYear = yearCentury + creditCard.specificParams.field5;
                            var expBufferDays = -7;
                            var expirationBeforeDate = new Date(expYear, expMonth, expBufferDays, 0, 0, 0, 0);
                            var expirationDateOnCard = new Date(expYear, expMonth, 0, 0, 0, 0, 0);
                            var expirationDate = expirationDateOnCard.setDate(expirationDateOnCard.getDate() + 1);

                            if (dateNow >= expirationDate) {
                                method.account[i]['alreadyExpired'] = true;
                            }

                            if (dateNow >= expirationBeforeDate && !method.account[i]['alreadyExpired']) {
                                method.account['hasExpiredCardsCustom'] = true;
                                method.account[i]['toBeExpiredCustom'] = true;
                                method.account[i]['expirationDateCustom'] = `${expMonth}/${expYear}`;
                            }
                        });

                        var accountsArr = method.account;
                        for (var i = accountsArr.length - 1; i >= 0; i -= 1) {
                            if (accountsArr[i]['alreadyExpired'] === true) {
                                accountsArr.splice(i, 1);
                            }
                        }

                        if (accountsArr.length === 0) {
                            method.account['hasExpiredCardsCustom'] = false;
                        }
                    }
                }
            });

            return methods;
        },

        addAccountsToSubMethods: function(accounts, method) {
            if (accounts['CreditCardDT'] && accounts['CreditCardDT'].code === 'CreditCardDT') {
                if (method.code === 'VIS' || method.code === 'ECA' || method.code === 'DIN' || method.code === 'DIS') {
                    var accountArray = [];
                    accounts['CreditCardDT'].account.forEach(function(acc) {
                        if (acc.subMethods && acc.subMethods.subMethod && acc.subMethods.subMethod[0] && acc.subMethods.subMethod[0].code === method.code) {
                            accountArray.push(acc);
                        }
                    });
                    method.account = accountArray;
                    return method.account;
                }
            }
        }
    });
});
